import type { Handler } from './handler';
import type { ApiFetchGameFilterOptionsPort } from './ports/api-fetch-game-filter-options.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';
import filterOptionsFallback from '~/assets/json/games-filter-options.fallback.json';

const CACHE_TTL_MS = 5 * 60 * 1000;

let cachedFilterOptions: GameFilterOptionsResponse | null = null;
let cachedAt = 0;
let inflight: Promise<GameFilterOptionsResponse | null> | null = null;

export const fetchGameFilterOptionsHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  ports = {
    apiFetchGameFilterOptions: resolveAdapter('apiFetchGameFilterOptions'),
  },
) => {
  if (cachedFilterOptions && Date.now() - cachedAt < CACHE_TTL_MS) {
    return { filterOptions: cachedFilterOptions };
  }

  if (inflight) {
    return { filterOptions: await inflight };
  }

  inflight = (async () => {
    const [filterOptions, fetchError] = await tryCatch(
      ports?.apiFetchGameFilterOptions.handle(),
    );

    if (fetchError) {
      console.error(
        '[fetchGameFilterOptionsHandler] ❌ Erro ao buscar opções de filtros da API:',
        fetchError,
      );

      return null;
    }

    cachedFilterOptions = filterOptions ?? null;
    cachedAt = Date.now();

    return cachedFilterOptions;
  })();

  try {
    const result = await inflight;

    if (result) return { filterOptions: result };

    return {
      filterOptions:
        filterOptionsFallback as unknown as GameFilterOptionsResponse,
    };
  } finally {
    inflight = null;
  }
};

type Params = undefined;

type Ports = { apiFetchGameFilterOptions: ApiFetchGameFilterOptionsPort };

type Result = Promise<{ filterOptions: GameFilterOptionsResponse | null }>;
